module.exports = __webpack_public_path__ + "img/img_logo.dec7609a.png";